import { z } from "zod";
import { BladeCommonSchema } from "../../../types";
import { CharacterRoleSchema } from "../../CharacterRole";
import { CharacterDifficultySchema } from "../../CharacterDifficulty";
import { BackdropSchema } from "../../Backdrop";
import { RichTextSchema } from "../../RichText";
import { LinkItemSchema } from "../../LinkItem";
export const CharacterMastheadBladeSchema = BladeCommonSchema.extend({
    backdrop: BackdropSchema,
    title: z.string(),
    subtitle: z.string().optional(),
    role: CharacterRoleSchema.optional(),
    difficulty: CharacterDifficultySchema.optional(),
    description: RichTextSchema.optional(),
    linksLabel: z.string().optional(),
    links: z.array(LinkItemSchema).optional(),
});
//# sourceMappingURL=index.js.map